module.exports = __webpack_public_path__ + "static/Real_Time_Communication-c99bbb8cd66402a032523a11fbb2b0ad.png";